/** MiniMax 官方系统音色（platform.minimaxi.com/docs/faq/system-voice-id） */
export type MiniMaxVoice = { id: string; name: string; language: string }

export const MINIMAX_SYSTEM_VOICES: MiniMaxVoice[] = [
  {
    "id": "male-qn-qingse",
    "name": "青涩青年音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-jingying",
    "name": "精英青年音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-badao",
    "name": "霸道青年音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-daxuesheng",
    "name": "青年大学生音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-shaonv",
    "name": "少女音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-yujie",
    "name": "御姐音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-chengshu",
    "name": "成熟女性音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-tianmei",
    "name": "甜美女性音色",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-qingse-jingpin",
    "name": "青涩青年音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-jingying-jingpin",
    "name": "精英青年音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-badao-jingpin",
    "name": "霸道青年音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "male-qn-daxuesheng-jingpin",
    "name": "青年大学生音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-shaonv-jingpin",
    "name": "少女音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-yujie-jingpin",
    "name": "御姐音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-chengshu-jingpin",
    "name": "成熟女性音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "female-tianmei-jingpin",
    "name": "甜美女性音色-beta",
    "language": "中文 (普通话)"
  },
  {
    "id": "clever_boy",
    "name": "聪明男童",
    "language": "中文 (普通话)"
  },
  {
    "id": "cute_boy",
    "name": "可爱男童",
    "language": "中文 (普通话)"
  },
  {
    "id": "lovely_girl",
    "name": "萌萌女童",
    "language": "中文 (普通话)"
  },
  {
    "id": "cartoon_pig",
    "name": "卡通猪小琪",
    "language": "中文 (普通话)"
  },
  {
    "id": "bingjiao_didi",
    "name": "病娇弟弟",
    "language": "中文 (普通话)"
  },
  {
    "id": "junlang_nanyou",
    "name": "俊朗男友",
    "language": "中文 (普通话)"
  },
  {
    "id": "chunzhen_xuedi",
    "name": "纯真学弟",
    "language": "中文 (普通话)"
  },
  {
    "id": "lengdan_xiongzhang",
    "name": "冷淡学长",
    "language": "中文 (普通话)"
  },
  {
    "id": "badao_shaoye",
    "name": "霸道少爷",
    "language": "中文 (普通话)"
  },
  {
    "id": "tianxin_xiaoling",
    "name": "甜心小玲",
    "language": "中文 (普通话)"
  },
  {
    "id": "qiaopi_mengmei",
    "name": "俏皮萌妹",
    "language": "中文 (普通话)"
  },
  {
    "id": "wumei_yujie",
    "name": "妩媚御姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "diadia_xuemei",
    "name": "嗲嗲学妹",
    "language": "中文 (普通话)"
  },
  {
    "id": "danya_xuejie",
    "name": "淡雅学姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Reliable_Executive",
    "name": "沉稳高管",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_News_Anchor",
    "name": "新闻女声",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Mature_Woman",
    "name": "傲娇御姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Unrestrained_Young_Man",
    "name": "不羁青年",
    "language": "中文 (普通话)"
  },
  {
    "id": "Arrogant_Miss",
    "name": "嚣张小姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "Robot_Armor",
    "name": "机械战甲",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Kind-hearted_Antie",
    "name": "热心大婶",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_HK_Flight_Attendant",
    "name": "港普空姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Humorous_Elder",
    "name": "搞笑大爷",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Gentleman",
    "name": "温润男声",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Warm_Bestie",
    "name": "温暖闺蜜",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Male_Announcer",
    "name": "播报男声",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Sweet_Lady",
    "name": "甜美女声",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Southern_Young_Man",
    "name": "南方小哥",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Wise_Women",
    "name": "阅历姐姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Gentle_Youth",
    "name": "温润青年",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Warm_Girl",
    "name": "温暖少女",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Kind-hearted_Elder",
    "name": "花甲奶奶",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Cute_Spirit",
    "name": "憨憨萌兽",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Radio_Host",
    "name": "电台男主播",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Lyrical_Voice",
    "name": "抒情男声",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Straightforward_Boy",
    "name": "率真弟弟",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Sincere_Adult",
    "name": "真诚青年",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Gentle_Senior",
    "name": "温柔学姐",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Stubborn_Friend",
    "name": "嘴硬竹马",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Crisp_Girl",
    "name": "清脆少女",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Pure-hearted_Boy",
    "name": "清澈邻家弟弟",
    "language": "中文 (普通话)"
  },
  {
    "id": "Chinese (Mandarin)_Soft_Girl",
    "name": "柔和少女",
    "language": "中文 (普通话)"
  },
  {
    "id": "Cantonese_ProfessionalHost（F)",
    "name": "专业女主持",
    "language": "中文 (粤语)"
  },
  {
    "id": "Cantonese_GentleLady",
    "name": "温柔女声",
    "language": "中文 (粤语)"
  },
  {
    "id": "Cantonese_ProfessionalHost（M)",
    "name": "专业男主持",
    "language": "中文 (粤语)"
  },
  {
    "id": "Cantonese_PlayfulMan",
    "name": "活泼男声",
    "language": "中文 (粤语)"
  },
  {
    "id": "Cantonese_CuteGirl",
    "name": "可爱女孩",
    "language": "中文 (粤语)"
  },
  {
    "id": "Cantonese_KindWoman",
    "name": "善良女声",
    "language": "中文 (粤语)"
  },
  {
    "id": "Santa_Claus",
    "name": "Santa Claus",
    "language": "英文"
  },
  {
    "id": "Grinch",
    "name": "Grinch",
    "language": "英文"
  },
  {
    "id": "Rudolph",
    "name": "Rudolph",
    "language": "英文"
  },
  {
    "id": "Arnold",
    "name": "Arnold",
    "language": "英文"
  },
  {
    "id": "Charming_Santa",
    "name": "Charming Santa",
    "language": "英文"
  },
  {
    "id": "Charming_Lady",
    "name": "Charming Lady",
    "language": "英文"
  },
  {
    "id": "Sweet_Girl",
    "name": "Sweet Girl",
    "language": "英文"
  },
  {
    "id": "Cute_Elf",
    "name": "Cute Elf",
    "language": "英文"
  },
  {
    "id": "Attractive_Girl",
    "name": "Attractive Girl",
    "language": "英文"
  },
  {
    "id": "Serene_Woman",
    "name": "Serene Woman",
    "language": "英文"
  },
  {
    "id": "English_Trustworthy_Man",
    "name": "Trustworthy Man",
    "language": "英文"
  },
  {
    "id": "English_Graceful_Lady",
    "name": "Graceful Lady",
    "language": "英文"
  },
  {
    "id": "English_Aussie_Bloke",
    "name": "Aussie Bloke",
    "language": "英文"
  },
  {
    "id": "English_Whispering_girl",
    "name": "Whispering girl",
    "language": "英文"
  },
  {
    "id": "English_Diligent_Man",
    "name": "Diligent Man",
    "language": "英文"
  },
  {
    "id": "English_Gentle-voiced_man",
    "name": "Gentle-voiced man",
    "language": "英文"
  },
  {
    "id": "Japanese_IntellectualSenior",
    "name": "Intellectual Senior",
    "language": "日文"
  },
  {
    "id": "Japanese_DecisivePrincess",
    "name": "Decisive Princess",
    "language": "日文"
  },
  {
    "id": "Japanese_LoyalKnight",
    "name": "Loyal Knight",
    "language": "日文"
  },
  {
    "id": "Japanese_DominantMan",
    "name": "Dominant Man",
    "language": "日文"
  },
  {
    "id": "Japanese_SeriousCommander",
    "name": "Serious Commander",
    "language": "日文"
  },
  {
    "id": "Japanese_ColdQueen",
    "name": "Cold Queen",
    "language": "日文"
  },
  {
    "id": "Japanese_DependableWoman",
    "name": "Dependable Woman",
    "language": "日文"
  },
  {
    "id": "Japanese_GentleButler",
    "name": "Gentle Butler",
    "language": "日文"
  },
  {
    "id": "Japanese_KindLady",
    "name": "Kind Lady",
    "language": "日文"
  },
  {
    "id": "Japanese_CalmLady",
    "name": "Calm Lady",
    "language": "日文"
  },
  {
    "id": "Japanese_OptimisticYouth",
    "name": "Optimistic Youth",
    "language": "日文"
  },
  {
    "id": "Japanese_GenerousIzakayaOwner",
    "name": "Generous Izakaya Owner",
    "language": "日文"
  },
  {
    "id": "Japanese_SportyStudent",
    "name": "Sporty Student",
    "language": "日文"
  },
  {
    "id": "Japanese_InnocentBoy",
    "name": "Innocent Boy",
    "language": "日文"
  },
  {
    "id": "Japanese_GracefulMaiden",
    "name": "Graceful Maiden",
    "language": "日文"
  },
  {
    "id": "Korean_SweetGirl",
    "name": "Sweet Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_CheerfulBoyfriend",
    "name": "Cheerful Boyfriend",
    "language": "韩文"
  },
  {
    "id": "Korean_EnchantingSister",
    "name": "Enchanting Sister",
    "language": "韩文"
  },
  {
    "id": "Korean_ShyGirl",
    "name": "Shy Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_ReliableSister",
    "name": "Reliable Sister",
    "language": "韩文"
  },
  {
    "id": "Korean_StrictBoss",
    "name": "Strict Boss",
    "language": "韩文"
  },
  {
    "id": "Korean_SassyGirl",
    "name": "Sassy Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_ChildhoodFriendGirl",
    "name": "Childhood Friend Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_PlayboyCharmer",
    "name": "Playboy Charmer",
    "language": "韩文"
  },
  {
    "id": "Korean_ElegantPrincess",
    "name": "Elegant Princess",
    "language": "韩文"
  },
  {
    "id": "Korean_BraveFemaleWarrior",
    "name": "Brave Female Warrior",
    "language": "韩文"
  },
  {
    "id": "Korean_BraveYouth",
    "name": "Brave Youth",
    "language": "韩文"
  },
  {
    "id": "Korean_CalmLady",
    "name": "Calm Lady",
    "language": "韩文"
  },
  {
    "id": "Korean_EnthusiasticTeen",
    "name": "Enthusiastic Teen",
    "language": "韩文"
  },
  {
    "id": "Korean_SoothingLady",
    "name": "Soothing Lady",
    "language": "韩文"
  },
  {
    "id": "Korean_IntellectualSenior",
    "name": "Intellectual Senior",
    "language": "韩文"
  },
  {
    "id": "Korean_LonelyWarrior",
    "name": "Lonely Warrior",
    "language": "韩文"
  },
  {
    "id": "Korean_MatureLady",
    "name": "Mature Lady",
    "language": "韩文"
  },
  {
    "id": "Korean_InnocentBoy",
    "name": "Innocent Boy",
    "language": "韩文"
  },
  {
    "id": "Korean_CharmingSister",
    "name": "Charming Sister",
    "language": "韩文"
  },
  {
    "id": "Korean_AthleticStudent",
    "name": "Athletic Student",
    "language": "韩文"
  },
  {
    "id": "Korean_BraveAdventurer",
    "name": "Brave Adventurer",
    "language": "韩文"
  },
  {
    "id": "Korean_CalmGentleman",
    "name": "Calm Gentleman",
    "language": "韩文"
  },
  {
    "id": "Korean_WiseElf",
    "name": "Wise Elf",
    "language": "韩文"
  },
  {
    "id": "Korean_CheerfulCoolJunior",
    "name": "Cheerful Cool Junior",
    "language": "韩文"
  },
  {
    "id": "Korean_DecisiveQueen",
    "name": "Decisive Queen",
    "language": "韩文"
  },
  {
    "id": "Korean_ColdYoungMan",
    "name": "Cold Young Man",
    "language": "韩文"
  },
  {
    "id": "Korean_MysteriousGirl",
    "name": "Mysterious Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_QuirkyGirl",
    "name": "Quirky Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_ConsiderateSenior",
    "name": "Considerate Senior",
    "language": "韩文"
  },
  {
    "id": "Korean_CheerfulLittleSister",
    "name": "Cheerful Little Sister",
    "language": "韩文"
  },
  {
    "id": "Korean_DominantMan",
    "name": "Dominant Man",
    "language": "韩文"
  },
  {
    "id": "Korean_AirheadedGirl",
    "name": "Airheaded Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_ReliableYouth",
    "name": "Reliable Youth",
    "language": "韩文"
  },
  {
    "id": "Korean_FriendlyBigSister",
    "name": "Friendly Big Sister",
    "language": "韩文"
  },
  {
    "id": "Korean_GentleBoss",
    "name": "Gentle Boss",
    "language": "韩文"
  },
  {
    "id": "Korean_ColdGirl",
    "name": "Cold Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_HaughtyLady",
    "name": "Haughty Lady",
    "language": "韩文"
  },
  {
    "id": "Korean_CharmingElderSister",
    "name": "Charming Elder Sister",
    "language": "韩文"
  },
  {
    "id": "Korean_IntellectualMan",
    "name": "Intellectual Man",
    "language": "韩文"
  },
  {
    "id": "Korean_CaringWoman",
    "name": "Caring Woman",
    "language": "韩文"
  },
  {
    "id": "Korean_WiseTeacher",
    "name": "Wise Teacher",
    "language": "韩文"
  },
  {
    "id": "Korean_ConfidentBoss",
    "name": "Confident Boss",
    "language": "韩文"
  },
  {
    "id": "Korean_AthleticGirl",
    "name": "Athletic Girl",
    "language": "韩文"
  },
  {
    "id": "Korean_PossessiveMan",
    "name": "Possessive Man",
    "language": "韩文"
  },
  {
    "id": "Korean_GentleWoman",
    "name": "Gentle Woman",
    "language": "韩文"
  },
  {
    "id": "Korean_CockyGuy",
    "name": "Cocky Guy",
    "language": "韩文"
  },
  {
    "id": "Korean_ThoughtfulWoman",
    "name": "Thoughtful Woman",
    "language": "韩文"
  },
  {
    "id": "Korean_OptimisticYouth",
    "name": "Optimistic Youth",
    "language": "韩文"
  },
  {
    "id": "Spanish_SereneWoman",
    "name": "Serene Woman",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_MaturePartner",
    "name": "Mature Partner",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_CaptivatingStoryteller",
    "name": "Captivating Storyteller",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Narrator",
    "name": "Narrator",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_WiseScholar",
    "name": "Wise Scholar",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Kind-heartedGirl",
    "name": "Kind-hearted Girl",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_DeterminedManager",
    "name": "Determined Manager",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_BossyLeader",
    "name": "Bossy Leader",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ReservedYoungMan",
    "name": "Reserved Young Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ConfidentWoman",
    "name": "Confident Woman",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ThoughtfulMan",
    "name": "Thoughtful Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Strong-WilledBoy",
    "name": "Strong-willed Boy",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_SophisticatedLady",
    "name": "Sophisticated Lady",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_RationalMan",
    "name": "Rational Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_AnimeCharacter",
    "name": "Anime Character",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Deep-tonedMan",
    "name": "Deep-toned Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Fussyhostess",
    "name": "Fussy hostess",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_SincereTeen",
    "name": "Sincere Teen",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_FrankLady",
    "name": "Frank Lady",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Comedian",
    "name": "Comedian",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Debator",
    "name": "Debator",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ToughBoss",
    "name": "Tough Boss",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Wiselady",
    "name": "Wise Lady",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Steadymentor",
    "name": "Steady Mentor",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Jovialman",
    "name": "Jovial Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_SantaClaus",
    "name": "Santa Claus",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Rudolph",
    "name": "Rudolph",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Intonategirl",
    "name": "Intonate Girl",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Arnold",
    "name": "Arnold",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_Ghost",
    "name": "Ghost",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_HumorousElder",
    "name": "Humorous Elder",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_EnergeticBoy",
    "name": "Energetic Boy",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_WhimsicalGirl",
    "name": "Whimsical Girl",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_StrictBoss",
    "name": "Strict Boss",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ReliableMan",
    "name": "Reliable Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_SereneElder",
    "name": "Serene Elder",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_AngryMan",
    "name": "Angry Man",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_AssertiveQueen",
    "name": "Assertive Queen",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_CaringGirlfriend",
    "name": "Caring Girlfriend",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_PowerfulSoldier",
    "name": "Powerful Soldier",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_PassionateWarrior",
    "name": "Passionate Warrior",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ChattyGirl",
    "name": "Chatty Girl",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_RomanticHusband",
    "name": "Romantic Husband",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_CompellingGirl",
    "name": "Compelling Girl",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_PowerfulVeteran",
    "name": "Powerful Veteran",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_SensibleManager",
    "name": "Sensible Manager",
    "language": "西班牙文"
  },
  {
    "id": "Spanish_ThoughtfulLady",
    "name": "Thoughtful Lady",
    "language": "西班牙文"
  },
  {
    "id": "Portuguese_SentimentalLady",
    "name": "Sentimental Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_BossyLeader",
    "name": "Bossy Leader",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Wiselady",
    "name": "Wise lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Strong-WilledBoy",
    "name": "Strong-willed Boy",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Deep-VoicedGentleman",
    "name": "Deep-voiced Gentleman",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_UpsetGirl",
    "name": "Upset Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_PassionateWarrior",
    "name": "Passionate Warrior",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_AnimeCharacter",
    "name": "Anime Character",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ConfidentWoman",
    "name": "Confident Woman",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_AngryMan",
    "name": "Angry Man",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CaptivatingStoryteller",
    "name": "Captivating Storyteller",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Godfather",
    "name": "Godfather",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ReservedYoungMan",
    "name": "Reserved Young Man",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SmartYoungGirl",
    "name": "Smart Young Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Kind-heartedGirl",
    "name": "Kind-hearted Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Pompouslady",
    "name": "Pompous lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Grinch",
    "name": "Grinch",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Debator",
    "name": "Debator",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SweetGirl",
    "name": "Sweet Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_AttractiveGirl",
    "name": "Attractive Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ThoughtfulMan",
    "name": "Thoughtful Man",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_PlayfulGirl",
    "name": "Playful Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_GorgeousLady",
    "name": "Gorgeous Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_LovelyLady",
    "name": "Lovely Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SereneWoman",
    "name": "Serene Woman",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SadTeen",
    "name": "Sad Teen",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_MaturePartner",
    "name": "Mature Partner",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Comedian",
    "name": "Comedian",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_NaughtySchoolgirl",
    "name": "Naughty Schoolgirl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Narrator",
    "name": "Narrator",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ToughBoss",
    "name": "Tough Boss",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Fussyhostess",
    "name": "Fussy hostess",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Dramatist",
    "name": "Dramatist",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Steadymentor",
    "name": "Steady Mentor",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Jovialman",
    "name": "Jovial Man",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CharmingQueen",
    "name": "Charming Queen",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SantaClaus",
    "name": "Santa Claus",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Rudolph",
    "name": "Rudolph",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Arnold",
    "name": "Arnold",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CharmingSanta",
    "name": "Charming Santa",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CharmingLady",
    "name": "Charming Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Ghost",
    "name": "Ghost",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_HumorousElder",
    "name": "Humorous Elder",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CalmLeader",
    "name": "Calm Leader",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_GentleTeacher",
    "name": "Gentle Teacher",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_EnergeticBoy",
    "name": "Energetic Boy",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ReliableMan",
    "name": "Reliable Man",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SereneElder",
    "name": "Serene Elder",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_GrimReaper",
    "name": "Grim Reaper",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_AssertiveQueen",
    "name": "Assertive Queen",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_WhimsicalGirl",
    "name": "Whimsical Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_StressedLady",
    "name": "Stressed Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_FriendlyNeighbor",
    "name": "Friendly Neighbor",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CaringGirlfriend",
    "name": "Caring Girlfriend",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_PowerfulSoldier",
    "name": "Powerful Soldier",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_FascinatingBoy",
    "name": "Fascinating Boy",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_RomanticHusband",
    "name": "Romantic Husband",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_StrictBoss",
    "name": "Strict Boss",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_InspiringLady",
    "name": "Inspiring Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_PlayfulSpirit",
    "name": "Playful Spirit",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ElegantGirl",
    "name": "Elegant Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_CompellingGirl",
    "name": "Compelling Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_PowerfulVeteran",
    "name": "Powerful Veteran",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_SensibleManager",
    "name": "Sensible Manager",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ThoughtfulLady",
    "name": "Thoughtful Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_TheatricalActor",
    "name": "Theatrical Actor",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_FragileBoy",
    "name": "Fragile Boy",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_ChattyGirl",
    "name": "Chatty Girl",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_Conscientiousinstructor",
    "name": "Conscientious Instructor",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_RationalMan",
    "name": "Rational Man",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_WiseScholar",
    "name": "Wise Scholar",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_FrankLady",
    "name": "Frank Lady",
    "language": "葡萄牙文"
  },
  {
    "id": "Portuguese_DeterminedManager",
    "name": "Determined Manager",
    "language": "葡萄牙文"
  },
  {
    "id": "French_Male_Speech_New",
    "name": "Level-Headed Man",
    "language": "法文"
  },
  {
    "id": "French_Female_News Anchor",
    "name": "Patient Female Presenter",
    "language": "法文"
  },
  {
    "id": "French_CasualMan",
    "name": "Casual Man",
    "language": "法文"
  },
  {
    "id": "French_MovieLeadFemale",
    "name": "Movie Lead Female",
    "language": "法文"
  },
  {
    "id": "French_FemaleAnchor",
    "name": "Female Anchor",
    "language": "法文"
  },
  {
    "id": "French_MaleNarrator",
    "name": "Male Narrator",
    "language": "法文"
  },
  {
    "id": "Indonesian_SweetGirl",
    "name": "Sweet Girl",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_ReservedYoungMan",
    "name": "Reserved Young Man",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_CharmingGirl",
    "name": "Charming Girl",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_CalmWoman",
    "name": "Calm Woman",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_ConfidentWoman",
    "name": "Confident Woman",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_CaringMan",
    "name": "Caring Man",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_BossyLeader",
    "name": "Bossy Leader",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_DeterminedBoy",
    "name": "Determined Boy",
    "language": "印尼文"
  },
  {
    "id": "Indonesian_GentleGirl",
    "name": "Gentle Girl",
    "language": "印尼文"
  },
  {
    "id": "German_FriendlyMan",
    "name": "Friendly Man",
    "language": "德文"
  },
  {
    "id": "German_SweetLady",
    "name": "Sweet Lady",
    "language": "德文"
  },
  {
    "id": "German_PlayfulMan",
    "name": "Playful Man",
    "language": "德文"
  },
  {
    "id": "Russian_HandsomeChildhoodFriend",
    "name": "Handsome Childhood Friend",
    "language": "俄文"
  },
  {
    "id": "Russian_BrightHeroine",
    "name": "Bright Queen",
    "language": "俄文"
  },
  {
    "id": "Russian_AmbitiousWoman",
    "name": "Ambitious Woman",
    "language": "俄文"
  },
  {
    "id": "Russian_ReliableMan",
    "name": "Reliable Man",
    "language": "俄文"
  },
  {
    "id": "Russian_CrazyQueen",
    "name": "Crazy Girl",
    "language": "俄文"
  },
  {
    "id": "Russian_PessimisticGirl",
    "name": "Pessimistic Girl",
    "language": "俄文"
  },
  {
    "id": "Russian_AttractiveGuy",
    "name": "Attractive Guy",
    "language": "俄文"
  },
  {
    "id": "Russian_Bad-temperedBoy",
    "name": "Bad-tempered Boy",
    "language": "俄文"
  },
  {
    "id": "Italian_BraveHeroine",
    "name": "Brave Heroine",
    "language": "意大利文"
  },
  {
    "id": "Italian_Narrator",
    "name": "Narrator",
    "language": "意大利文"
  },
  {
    "id": "Italian_WanderingSorcerer",
    "name": "Wandering Sorcerer",
    "language": "意大利文"
  },
  {
    "id": "Italian_DiligentLeader",
    "name": "Diligent Leader",
    "language": "意大利文"
  },
  {
    "id": "Arabic_CalmWoman",
    "name": "Calm Woman",
    "language": "阿拉伯文"
  },
  {
    "id": "Arabic_FriendlyGuy",
    "name": "Friendly Guy",
    "language": "阿拉伯文"
  },
  {
    "id": "Turkish_CalmWoman",
    "name": "Calm Woman",
    "language": "土耳其文"
  },
  {
    "id": "Turkish_Trustworthyman",
    "name": "Trustworthy man",
    "language": "土耳其文"
  },
  {
    "id": "Ukrainian_CalmWoman",
    "name": "Calm Woman",
    "language": "乌克兰文"
  },
  {
    "id": "Ukrainian_WiseScholar",
    "name": "Wise Scholar",
    "language": "乌克兰文"
  },
  {
    "id": "Dutch_kindhearted_girl",
    "name": "Kind-hearted girl",
    "language": "荷兰文"
  },
  {
    "id": "Dutch_bossy_leader",
    "name": "Bossy leader",
    "language": "荷兰文"
  },
  {
    "id": "Vietnamese_kindhearted_girl",
    "name": "Kind-hearted girl",
    "language": "越南文"
  },
  {
    "id": "Thai_male_1_sample8",
    "name": "Serene Man",
    "language": "泰文"
  },
  {
    "id": "Thai_male_2_sample2",
    "name": "Friendly Man",
    "language": "泰文"
  },
  {
    "id": "Thai_female_1_sample1",
    "name": "Confident Woman",
    "language": "泰文"
  },
  {
    "id": "Thai_female_2_sample2",
    "name": "Energetic Woman",
    "language": "泰文"
  },
  {
    "id": "Polish_male_1_sample4",
    "name": "Male Narrator",
    "language": "波兰文"
  },
  {
    "id": "Polish_male_2_sample3",
    "name": "Male Anchor",
    "language": "波兰文"
  },
  {
    "id": "Polish_female_1_sample1",
    "name": "Calm Woman",
    "language": "波兰文"
  },
  {
    "id": "Polish_female_2_sample3",
    "name": "Casual Woman",
    "language": "波兰文"
  },
  {
    "id": "Romanian_male_1_sample2",
    "name": "Reliable Man",
    "language": "罗马尼亚文"
  },
  {
    "id": "Romanian_male_2_sample1",
    "name": "Energetic Youth",
    "language": "罗马尼亚文"
  },
  {
    "id": "Romanian_female_1_sample4",
    "name": "Optimistic Youth",
    "language": "罗马尼亚文"
  },
  {
    "id": "Romanian_female_2_sample1",
    "name": "Gentle Woman",
    "language": "罗马尼亚文"
  },
  {
    "id": "greek_male_1a_v1",
    "name": "Thoughtful Mentor",
    "language": "希腊文"
  },
  {
    "id": "Greek_female_1_sample1",
    "name": "Gentle Lady",
    "language": "希腊文"
  },
  {
    "id": "Greek_female_2_sample3",
    "name": "Girl Next Door",
    "language": "希腊文"
  },
  {
    "id": "czech_male_1_v1",
    "name": "Assured Presenter",
    "language": "捷克文"
  },
  {
    "id": "czech_female_5_v7",
    "name": "Steadfast Narrator",
    "language": "捷克文"
  },
  {
    "id": "czech_female_2_v2",
    "name": "Elegant Lady",
    "language": "捷克文"
  },
  {
    "id": "finnish_male_3_v1",
    "name": "Upbeat Man",
    "language": "芬兰文"
  },
  {
    "id": "finnish_male_1_v2",
    "name": "Friendly Boy",
    "language": "芬兰文"
  },
  {
    "id": "finnish_female_4_v1",
    "name": "Assetive Woman",
    "language": "芬兰文"
  },
  {
    "id": "hindi_male_1_v2",
    "name": "Trustworthy Advisor",
    "language": "印地文"
  },
  {
    "id": "hindi_female_2_v1",
    "name": "Tranquil Woman",
    "language": "印地文"
  },
  {
    "id": "hindi_female_1_v2",
    "name": "News Anchor",
    "language": "印地文"
  }
]

export function findMiniMaxVoice(id?: string): MiniMaxVoice | undefined {
  const v = (id ?? '').trim()
  if (!v) return undefined
  return MINIMAX_SYSTEM_VOICES.find((x) => x.id === v)
}

export function miniMaxVoiceLabel(id?: string, fallback?: string): string {
  return findMiniMaxVoice(id)?.name ?? fallback ?? id ?? ''
}

export function inferMiniMaxVoiceGender(voice: MiniMaxVoice): 'male' | 'female' | 'neutral' {
  const id = voice.id.toLowerCase()
  const name = voice.name
  if (
    id.startsWith('male-') ||
    id.includes('_male') ||
    id.includes('boy') ||
    id.includes('man') ||
    name.includes('男')
  ) {
    return 'male'
  }
  if (
    id.startsWith('female-') ||
    id.includes('_female') ||
    id.includes('girl') ||
    id.includes('lady') ||
    id.includes('woman') ||
    name.includes('女')
  ) {
    return 'female'
  }
  return 'neutral'
}

export function miniMaxVoiceMeta(voice: MiniMaxVoice): string {
  const gender = inferMiniMaxVoiceGender(voice)
  const genderLabel = gender === 'male' ? '男' : gender === 'female' ? '女' : ''
  return genderLabel ? `${voice.language} ${genderLabel}` : voice.language
}
